var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { Cross } from '../../svgs';
export function SnowDayBanner(props) {
    var _a;
    if (!((_a = props === null || props === void 0 ? void 0 : props.data) === null || _a === void 0 ? void 0 : _a.Active))
        return null;
    var _b = props.data, Message = _b.Message, Link = _b.Link;
    function handleClose(event) {
        props.close();
    }
    return (_jsxs(StyledSnowDayBanner, { children: [_jsx("a", __assign({ href: Link || undefined, target: '_blank', rel: 'noopener noreferrer' }, { children: Message }), void 0),
            _jsx(Cross, { className: 'close-snow', onClick: handleClose }, void 0)] }, void 0));
}
var StyledSnowDayBanner = styled.header(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  background-color: var(--ev-red);\n  align-items: baseline;\n  a {\n    color: white;\n    font-size: 1.6rem;\n    display: inline-block;\n    flex: 1;\n    padding: 10px 20px;\n    text-align: center;\n  }\n  .close-snow {\n    cursor: pointer;\n    width: 15px;\n    height: 15px;\n    fill: white;\n    margin-right: 20px;\n  }\n"], ["\n  display: flex;\n  background-color: var(--ev-red);\n  align-items: baseline;\n  a {\n    color: white;\n    font-size: 1.6rem;\n    display: inline-block;\n    flex: 1;\n    padding: 10px 20px;\n    text-align: center;\n  }\n  .close-snow {\n    cursor: pointer;\n    width: 15px;\n    height: 15px;\n    fill: white;\n    margin-right: 20px;\n  }\n"])));
var templateObject_1;
